module.exports = __webpack_public_path__ + "media/bootstrap-icons/percent-8f2d8efa.svg";